// mixpanel.js
import mixpanel from 'mixpanel-browser';

mixpanel.init('b6a86258334586ab523bda26ae5924d7', {
  debug: true, // set to false in production
});

export default mixpanel;